import { render, staticRenderFns } from "./diseaseManagementPop.vue?vue&type=template&id=51551f21"
import script from "./diseaseManagementPop.vue?vue&type=script&lang=js"
export * from "./diseaseManagementPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51551f21')) {
      api.createRecord('51551f21', component.options)
    } else {
      api.reload('51551f21', component.options)
    }
    module.hot.accept("./diseaseManagementPop.vue?vue&type=template&id=51551f21", function () {
      api.rerender('51551f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/diseaseManagementPop.vue"
export default component.exports